existingLinkTags